export const routes = {
	// Account routes
	accountLoginPhone: '/account/login',
	requestAccountVerificationCode: '/account/request-verification-code',
	validateAndRequestAccountVerificationCode: '/account/validate-request-verification-code',
	verifyCode: '/account/verify-code',
	accountLoginGoogle: '/account/google',
	accountLoginFacebook: '/account/facebook',
	createAccountWithPhone: '/account/create-account-by-phone',
	createPartialAccount: '/account/create-partial-account',
	accountPhoneComplete: '/account/phone/complete',
	getResetCode: '/account/get-reset-code',

	// User routes
	userProfile: '/user/profile',
	users: '/user/all',
	user: '/user',
	userRoles: '/user/roles',
	userProfileQuestion: '/user/question',
	userProfilePicture: '/user/avatar',

	// Product routes
	products: '/product/getproducts',
	productDetails: '/product/:productId',
	productFavorite: '/product/:productId/favorite',
	productUnfavorite: '/product/:productId/unfavorite',
	productAvailableSurveysQrCodes: '/product/available-surveys-qrcodes',

	// Brand routes
	addBrand: '/brand/addbrand',
	brandList: '/brand/GetAllBrandsAsync',
	brand: '/brand/GetByBrandId',
	deleteBrand: '/brand/delete',
	editBrand: '/brand/editbrand',

	// Survey routes
	dynmaiclinkqrCode: 'survey/dynmaiclinkqrCode',
	productScanHistory: '/survey/:productId/productscanhistory',

	// Reward routes
	rewardHistory: '/reward/history',

	// Search routes
	searchBrand: '/search/getBrandsAndProducts',

	// Feedback routes
	ongoingFeedBack: '/feedback/ongoing',

	// Category routes
	categories: '/categories',
	categoryProducts: '/categories/:categoryId/products',

	// Image routes
	imageUpload: '/image/upload',
};
